<template>
  <b-modal
    id="collect-money"
    modal-class="modal-style two-footer-btn"
    ref="modal"
  >
    <!-- //TODO: currency format -->
    <template>
      <p class="modal-style-title modal-title">本次收款金額 $ {{ amount }}</p>
      <div class="modal-style-content">
        <p>
          請確認是否正確
        </p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="transparent-btn" @click="$bvModal.hide(`collect-money`)">
        取消
      </button>
      <button class="custom-btn" @click="handlePay">
        確認
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    amount: {
      required: false,
      type: Number,
      default() {
        return 0;
      }
    }
  },
  methods: {
    handlePay() {
      this.$emit('handlePay');
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-title {
  color: #ff0000;
}
</style>
